<template>
	<client-only>
		<date-picker
			v-model:value="dateString"
			value-type="format"
			format="DD-MM-YYYY"
			:lang="datepickerLang"
			:placeholder="$t(`form${capitalize(field.name)}`)"
		>
			<template #icon-calendar> &nbsp; </template>
		</date-picker>
	</client-only>
</template>

<script setup>
import DatePicker from 'vue-datepicker-next';
import 'vue-datepicker-next/index.css';
import datePickerTranslations from '~/i18n/datePicker.js';

const { locale } = useI18n();

defineProps({
	field: { type: Object, required: true },
});

const dateString = defineModel('datefield', { type: String, default: '' });

const datepickerLang = computed(() => datePickerTranslations[locale.value] ?? datePickerTranslations.en);
</script>

<style>
.contact-form .mx-input {
	border-radius: 0 !important;
}
</style>

<style scoped lang="scss">
.mx-datepicker {
	width: 100%;
}
</style>
